import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { ConfigProvider, DatePicker, Space } from "antd";
import moment from "moment";

import dayjs from "dayjs";
import SelectBox from "../CustomWidgets/SelectBox";
const { RangePicker } = DatePicker;

const formatDate = (date) => dayjs(date).format("YYYY-MM-DD");


const disabledDate = (current) => {
  // Disable dates that are after today
  return current && current > moment().endOf("day");
};

const DateFilter = ({ setSelectedRange, selectedRange ,SubmitFilter, disabled, isAllTime }) => {
  const { t, i18n } = useTranslation();
  const today = dayjs();
  const formatToday = today.format("DD/MM/YYYY");
  const disabledDate = (current) => {
    // Disable dates that are after today
    return current && current > moment().endOf("day");
  };

  const getLabelWithDates = (key) => {
    let startDate, endDate;

    switch (key) {
      case "today":
        startDate = today.format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "thisWeek":
        startDate = today.startOf("week").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "thisMonth":
        startDate = today.startOf("month").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "thisYear":
        startDate = today.startOf("year").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "lastWeek":
        startDate = today.subtract(1, "week").startOf("week").format("DD/MM/YYYY");
        endDate = today.subtract(1, "week").endOf("week").format("DD/MM/YYYY");
        break;
      case "lastMonth":
        startDate = today.subtract(1, "month").startOf("month").format("DD/MM/YYYY");
        endDate = today.subtract(1, "month").endOf("month").format("DD/MM/YYYY");
        break;
      case "lastYear":
        startDate = today.subtract(1, "year").startOf("year").format("DD/MM/YYYY");
        endDate = today.subtract(1, "year").endOf("year").format("DD/MM/YYYY");
        break;
      case "last7Days":
        startDate = today.subtract(6, "day").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "last14Days":
        startDate = today.subtract(13, "day").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "last30Days":
        startDate = today.subtract(29, "day").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "last60Days":
        startDate = today.subtract(59, "day").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "last90Days":
        startDate = today.subtract(89, "day").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      case "last12Months":
        startDate = today.subtract(12, "month").add(1, "day").format("DD/MM/YYYY");
        endDate = today.format("DD/MM/YYYY");
        break;
      default:
        return "";
    }

    return `(${startDate} - ${endDate === today.format("DD/MM/YYYY") ? t("Today") : endDate})`;
  };

  const types = [
     ...(isAllTime ? [{ value: "all", label: t("All") }] : []),
    { value: "today", label: `${t("Today")} (${formatToday})` },
    { value: "thisWeek", label: `${t("This Week")} ${getLabelWithDates("thisWeek")}` },
    { value: "thisMonth", label: `${t("This Month")} ${getLabelWithDates("thisMonth")}` },
    { value: "thisYear", label: `${t("This Year")} ${getLabelWithDates("thisYear")}` },
    { value: "lastWeek", label: `${t("Last Week")} ${getLabelWithDates("lastWeek")}` },
    { value: "lastMonth", label: `${t("Last Month")} ${getLabelWithDates("lastMonth")}` },
    { value: "lastYear", label: `${t("Last Year")} ${getLabelWithDates("lastYear")}` },
    { value: "last7Days", label: `${t("Last 7 Days")} ${getLabelWithDates("last7Days")}` },
    { value: "last14Days", label: `${t("Last 14 Days")} ${getLabelWithDates("last14Days")}` },
    { value: "last30Days", label: `${t("Last 30 Days")} ${getLabelWithDates("last30Days")}` },
    { value: "last60Days", label: `${t("Last 60 Days")} ${getLabelWithDates("last60Days")}` },
    { value: "last90Days", label: `${t("Last 90 Days")} ${getLabelWithDates("last90Days")}` },
    { value: "last12Months", label: `${t("Last 12 Months")} ${getLabelWithDates("last12Months")}` },
    { value: "custom", label: t("Custom Range") },
  ];
  const handleDateRangeChange = (range) => {
    let CurrentSelection = range.target.value;
    setSelectedRange(CurrentSelection);

    const today = dayjs();
    let startDate, endDate;

    switch (CurrentSelection) {
        case "all":
        startDate = '';
        endDate = '';
        break;
      case "today":
        startDate = today.format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "thisWeek":
        startDate = today.startOf("week").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "thisMonth":
        startDate = today.startOf("month").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "thisYear":
        startDate = today.startOf("year").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "lastWeek":
        startDate = today.subtract(1, "week").startOf("week").format("YYYY-MM-DD");
        endDate = today.subtract(1, "week").endOf("week").format("YYYY-MM-DD");
        break;
      case "lastMonth":
        startDate = today.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        endDate = today.subtract(1, "month").endOf("month").format("YYYY-MM-DD");
        break;
      case "lastYear":
        startDate = today.subtract(1, "year").startOf("year").format("YYYY-MM-DD");
        endDate = today.subtract(1, "year").endOf("year").format("YYYY-MM-DD");
        break;
      case "last7Days":
        startDate = today.subtract(6, "day").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "last14Days":
        startDate = today.subtract(13, "day").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "last30Days":
        startDate = today.subtract(29, "day").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "last60Days":
        startDate = today.subtract(59, "day").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "last90Days":
        startDate = today.subtract(89, "day").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "last12Months":
        startDate = today.subtract(12, "month").add(1, "day").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
        break;
      case "custom":
        return;
      default:
        return;
    }
console.log("tartDate, endDate,",startDate, endDate);

    SubmitFilter(startDate, endDate);
  };

  const handleRangePickerChange = (dates) => {
    if (dates) {
      console.log("dates==>", dates);

      const startDate = formatDate(dates[0]);
      const endDate = formatDate(dates[1]);
      SubmitFilter(startDate, endDate);
    }
  };

  return (
   <div className={`flex gap-x-2 ${
    selectedRange === "custom" ? "w-auto" : "w-64"
   }`}>
  {/* Dropdown for selecting the date range */}
  <SelectBox
    value={selectedRange}
    options={types}
    onChange={handleDateRangeChange}
    width={'w-64'}
    placeholder={t("select_date_range")}
    className=" h-10 bg-slate-600"   // 👈 increase width here (w-64 = ~16rem)
    disabled={disabled}
  />
  {/* RangePicker for custom date selection */}
  {selectedRange === "custom" && (
    <ConfigProvider direction={i18n.language === "ar" ? "rtl" : "ltr"}>
      <RangePicker
        className="h-10 md:mt-2 w-72 range-picker-placeholder" // 👈 increase width here
        style={{ minWidth: 300 }} // 👈 bigger min width
        onChange={handleRangePickerChange}
        placeholder={[t("Start Date"), t("End Date")]}
        disabledDate={disabledDate}
      />
    </ConfigProvider>
  )}
</div>
  );
};

export default DateFilter;
